import { Component, Input, OnInit } from '@angular/core';
import { AppealsService } from 'src/app/services/appeals.service';

@Component({
  selector: 'app-violations',
  templateUrl: './violations.component.html',
  styleUrls: ['./violations.component.scss'],
})
export class ViolationsComponent implements OnInit {
@Input() violation;
  constructor(
    public appealsSRV:AppealsService,
  ) { }

  ngOnInit() {
   
    
  }

}
